import { useCallback } from 'react';

import { appStore } from '@kaltura-ott/tvpil-shared';

interface Props {
  restartRetryConnection: (() => void) | undefined;
  setIsPendingRetry: (value: React.SetStateAction<boolean>) => void;
  clearError: () => void;
  onRetry: (() => void) | undefined;
  isErrorFromTvpil: boolean | undefined;
  isRhinoError: boolean | undefined;
  autoRetryTimer: number | undefined;
  timerInterval: NodeJS.Timer | undefined;
}

export const useHandleRetry = ({
  restartRetryConnection,
  setIsPendingRetry,
  clearError,
  onRetry,
  isErrorFromTvpil,
  isRhinoError,
  autoRetryTimer,
  timerInterval,
}: Props) => {
  return useCallback(async () => {
    if (onRetry) {
      if (timerInterval) {
        clearInterval(timerInterval);
      }

      setIsPendingRetry(true);
      await onRetry();

      if (!appStore.apiError && isErrorFromTvpil) {
        clearError();
      }

      if ((appStore.apiError || isRhinoError) && autoRetryTimer && restartRetryConnection) {
        setIsPendingRetry(true);
        restartRetryConnection();
      }
    } else {
      window.location.reload();
    }
  }, [restartRetryConnection, clearError, onRetry, isErrorFromTvpil, isRhinoError, autoRetryTimer, timerInterval]);
};
